<template>
    <div class="Bomb">
        <div class="bomb_nav">
            <div class="left_page">
                <div class="item" @click="ChangeBomb('1')" :class="{ 'active': Status == 1 }">
                    <p>
                        <img v-if="Status == 1" src="@/assets/images/new-ui/box_fight_record_s.png" alt="">
                        <img v-else src="@/assets/images/new-ui/box_fight_record_n.png" alt="">
                        排雷行动
                    </p>
                    <i></i>
                </div>
                <div class="item" @click="ChangeBomb('2')" :class="{ 'active': Status == 2 }">
                    <p>
                        <img v-if="Status == 2" src="@/assets/images/new-ui/box_fight_record_s.png" alt="">
                        <img v-else src="@/assets/images/new-ui/box_fight_record_n.png" alt="">
                        排雷记录
                    </p>
                    <i></i>
                </div>

            </div>

        </div>

        <div class="tdrt">
            <div class="tdrt_left" @click="RandomAward()">
                <div class="left_icon">
                </div>
                <div class="text">
                    <span style="color: #ffffff;">重置战场</span>
                    <span style="font-size: 10px;">试试运气</span>
                </div>
            </div>

            <div class="tdrt_right" >
                <div class="jgqj"  @mouseenter="mouseenter()" @mouseleave="mouseleave()">
                    <!-- <span>0</span>
                    <span>~</span>
                    <span>10</span> -->
                    <span>价格区间</span>
                    <img src="@/assets/images/bomb/sjx.png" alt="">

                    <div class="menu"  :class="{ 'active': mouseIsUser == true }">
                        <div class="menu_item">
                            0-10
                        </div>
                        <div class="menu_item">
                            10-100
                        </div>
                        <div class="menu_item">
                            100-500
                        </div>
                        <div class="menu_item">
                            500-2000
                        </div>
                    </div>

                </div>

                <div class="money">
                    <p>本局花费:</p>
                    <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                    <span>{{bean}}</span>
                </div>
                <p>玩法说明</p>
            </div>
        </div>

        <div class="winsbox">
            <div class="winsbox_left">
                <div class="winsbox_left_top">
                    本层奖励饰品
                </div>
                <div class="line">
                </div>
                <div class="winsbox_left_bottom">
                    <template v-if="awardList.length > 0">
                        <div class="Img">
                            <img :src=awardList[0].cover alt="">
                        </div>
                        <div class="name_price">
                            <div class="nickname">
                                {{awardList[0].name}}({{awardList[0].dura_alias}})
                            </div>
                            <div class="price">
                                <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                                <span>{{awardList[0].bean}}</span>
                            </div>
                        </div>


                </template>
                </div>
            </div>
            <div class="winsbox_right">
                <div class="up">
                </div>
                <div class="wins">
                    <div class="winsCard" v-for="(item, index) in awardList" :key="index">
                        <div class="pic">
                            <img :src=item.cover alt="">
                        </div>
                        <div class="price">
                            <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                            <span>{{item.bean}}</span>
                        </div>
                        <div class="nickname">
                            {{awardList[0].name}}({{awardList[0].dura_alias}})
                        </div>
                       
                        <div class="dp">
                            <img :src="GetLayerIcon(index+1)" alt="">
                        </div>
                    </div>
                </div>
                <div class="next">
                </div>
            </div>

        </div>
        <div class="boxs_big">
            <div class="boxs_big_left">
                <div class="boxs_big_left_top">
                    
                    <div class="boxs_big_left_top_title">
                        每层分布详情
                    </div>
                    <div class="line">
                    </div>
                    <div class="listbox">
                        <div class="item">
                            <div class="noceng">
                                第6层
                            </div>
                            <div class="dao">
                                <img src="@/assets/images/bomb/dao.png" alt="">
                            </div>
                            <div class="daonum">
                                x1
                            </div>
                            <div class="lei">
                                <img src="@/assets/images/bomb/lei.png" alt="">
                            </div>
                            <div class="daonum">
                                x1
                            </div>
                        </div>
                        <div class="item">
                            <div class="noceng">
                                第5层
                            </div>
                            <div class="dao">
                                <img src="@/assets/images/bomb/dao.png" alt="">
                            </div>
                            <div class="daonum">
                                x1
                            </div>
                            <div class="lei">
                                <img src="@/assets/images/bomb/lei.png" alt="">
                            </div>
                            <div class="daonum">
                                x2
                            </div>
                        </div>
                        <div class="item">
                            <div class="noceng">
                                第4层
                            </div>
                            <div class="dao">
                                <img src="@/assets/images/bomb/dao.png" alt="">
                            </div>
                            <div class="daonum">
                                x2
                            </div>
                            <div class="lei">
                                <img src="@/assets/images/bomb/lei.png" alt="">
                            </div>
                            <div class="daonum">
                                x2
                            </div>
                        </div>
                        <div class="item">
                            <div class="noceng">
                                第3层
                            </div>
                            <div class="dao">
                                <img src="@/assets/images/bomb/dao.png" alt="">
                            </div>
                            <div class="daonum">
                                x2
                            </div>
                            <div class="lei">
                                <img src="@/assets/images/bomb/lei.png" alt="">
                            </div>
                            <div class="daonum">
                                x3
                            </div>
                        </div>
                        <div class="item">
                            <div class="noceng">
                                第2层
                            </div>
                            <div class="dao">
                                <img src="@/assets/images/bomb/dao.png" alt="">
                            </div>
                            <div class="daonum">
                                x3
                            </div>
                            <div class="lei">
                                <img src="@/assets/images/bomb/lei.png" alt="">
                            </div>
                            <div class="daonum">
                                x3
                            </div>
                        </div>
                        <div class="item">
                            <div class="noceng">
                                第1层
                            </div>
                            <div class="dao">
                                <img src="@/assets/images/bomb/dao.png" alt="">
                            </div>
                            <div class="daonum">
                                x3
                            </div>
                            <div class="lei">
                                <img src="@/assets/images/bomb/lei.png" alt="">
                            </div>
                            <div class="daonum">
                                x4
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="boxs_big_right">
                <div class="ts">
                    <template v-if="layer_6.length > 0">
                        <template v-for="v of 2">
                            <template v-if="layer_6[v-1] == 0">
                                <div class="bomb">
                                    <img src="@/assets/images/bomb/boom.png" alt="">
                                </div>
                            </template>
                            <template v-else>
                                <div class="award">
                                    <img :src=awardList[5].cover alt="">
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="v of 2">
                            <div class="bgs" @click="PostOpenBomb(6,v)">
                                <img src="@/assets/images/bomb/wen1.png" alt="">
                            </div>
                        </template>
                    </template>
                </div>
                <div class="ts">
                    <template v-if="layer_5.length > 0">
                        <template v-for="v of 3">
                            <template v-if="layer_5[v-1] == 0">
                                <div class="bomb">
                                    <img src="@/assets/images/bomb/boom.png" alt="">
                                </div>
                            </template>
                            <template v-else>
                                <div class="award">
                                    <img :src=awardList[4].cover alt="">
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="v of 3">
                            <div class="bgs" @click="PostOpenBomb(5,v)">
                                <img src="@/assets/images/bomb/wen1.png" alt="">
                            </div>
                        </template>
                    </template>
                </div>
                <div class="ts">
                    <template v-if="layer_4.length > 0">
                        <template v-for="v of 4">
                            <template v-if="layer_4[v-1] == 0">
                                <div class="bomb">
                                    <img src="@/assets/images/bomb/boom.png" alt="">
                                </div>
                            </template>
                            <template v-else>
                                <div class="award">
                                    <img :src=awardList[3].cover alt="">
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="v of 4">
                            <div class="bgs" @click="PostOpenBomb(4,v)">
                                <img src="@/assets/images/bomb/wen2.png" alt="">
                            </div>
                        </template>
                    </template>
                </div>
                <div class="ts">
                    <template v-if="layer_3.length > 0">
                        <template v-for="v of 5">
                            <template v-if="layer_3[v-1] == 0">
                                <div class="bomb">
                                    <img src="@/assets/images/bomb/boom.png" alt="">
                                </div>
                            </template>
                            <template v-else>
                                <div class="award">
                                    <img :src=awardList[2].cover alt="">
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="v of 5">
                            <div class="bgs" @click="PostOpenBomb(3,v)">
                                <img src="@/assets/images/bomb/wen2.png" alt="">
                            </div>
                        </template>
                    </template>
                </div>

                <div class="ts">
                    <template v-if="layer_2.length > 0">
                        <template v-for="v of 6">
                            <template v-if="layer_2[v-1] == 0">
                                <div class="bomb">
                                    <img src="@/assets/images/bomb/boom.png" alt="">
                                </div>
                            </template>
                            <template v-else>
                                <div class="award">
                                    <img :src=awardList[1].cover alt="">
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="v of 6">
                            <div class="bgs" @click="PostOpenBomb(2,v)">
                                <img src="@/assets/images/bomb/wen3.png" alt="">
                            </div>
                        </template>
                    </template>
                </div>

                <div class="ts">
                    <template v-if="layer_1.length > 0">
                        <template v-for="v of 7">
                            <template v-if="layer_1[v-1] == 0">
                                <div class="bomb">
                                    <img src="@/assets/images/bomb/boom.png" alt="">
                                </div>
                            </template>
                            <template v-else>
                                <div class="award">
                                    <img :src=awardList[0].cover alt="">
                                </div>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="v of 7">
                            <div class="bgs" @click="PostOpenBomb(1,v)">
                                <img src="@/assets/images/bomb/wen3.png" alt="">
                            </div>
                        </template>
                    </template>
                </div>

                <div class="loadings" v-if="currentLayer == 0">
                    <div class="btns" @click="ConfirmBomb()">
                        <span>开始行动</span>
                        <div class="price">
                            <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                            <span>{{bean}}</span>
                        </div>
                    </div>
                </div>
                <div class="over_btns" v-if="currentLayer != 0"  @click="OverBomb()">
                    结束行动
                </div>
                
            </div>
            
        </div>
        

        <van-overlay :show="showStartTC">
            <div class="wrapper">
                <div class="startTC_content">
                    <div class="startTC_title">
                    开始游戏
                    </div>
                    <div class="startTC_bottom">
                        <div class="size">
                            是否消耗
                            <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                            <span>{{bean}}</span>
                            开始排雷行动 
                        </div>
                        <div class="btns">
                            <div class="cancel" @click="CancelBomb">
                                取消
                            </div>
                            <div class="ok" @click="PostStartBomb">
                                确定
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-overlay>

        <van-overlay :show="showAward" v-if="showAward">
            <div class="wrapper">
                <div class="gxhdcontent">
                    <div class="title">
                        恭喜获得
                    </div>
                    <div class="gxhdPic">
                        <img :src=award.cover alt="">
                    </div>
                    <div class="price">
                        <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                        <span>{{award.bean}}</span>
                    </div>
                    <div class="nickname">
                        {{award.name}}({{award.dura_alias}})
                    </div>
                    <div class="btns">
                        <div class="rs" @click="GetAward(1)">
                            放入背包
                        </div>
                        <div class="color_rs" @click="CloseAwardDlg">
                            继续行动
                        </div>
                    </div>
                    
                </div>
            </div>
        </van-overlay>
        
        
        <van-overlay :show="showFailAward" v-if="showFailAward">
            <div class="wrapper">
                <div class="gxhdcontent">
                    <div class="title">
                        行动失败
                    </div>
                    <div class="gxhdPic">
                        <img :src=fail_award.cover alt="">
                    </div>
                    <div class="price">
                        <img src="@/assets/images/PublicImg/JinBi.png" alt="">
                        <span>{{fail_award.bean}}</span>
                    </div>
                    <div class="nickname">
                        {{fail_award.name}}({{fail_award.dura_alias}})
                    </div>
                    <div class="btns">
                        <div class="rs" @click="GetFailAward()">
                            放入背包
                        </div>
                        <div class="color_rs" @click="PostCash()">
                            回收
                        </div>
                    </div>
                    
                </div>
            </div>
        </van-overlay>


    </div>
</template>

<script>
import { BombInfo, PersonalInfo,RandomPrice ,StartBomb, OpenBomb, GetBombAward, Cash} from '@/network/api.js'
import {
    mapState,
    mapMutations
} from 'vuex'

export default {
    name: 'Bomb',
    data() {
        return {
            bean: 0,
            Status: '1',    ///1 排雷 2记录
            mouseIsUser: false,
            awardList:[],   //每层奖励
            showStartTC: false, ///

            currentLayer:  0,///
            layer_1: [],    ///1层的数据
            layer_2: [],    ///2层的数据
            layer_3: [],    ///3层的数据
            layer_4: [],    ///4层的数据
            layer_5: [],    ///3层的数据
            layer_6: [],    ///4层的数据

            award: null,    ///奖励数据
            showAward: false,   ///
            showFailAward : false,
            fail_award: null,

            sound_1: new Audio(require('@/assets/images/bomb/3.mp3')),
            sound_2: new Audio(require('@/assets/images/bomb/6.mp3')),
        }
    },

    created() {
        this.GetBombInfo();
    },

    methods: {
        GetLayerIcon(level) {
			if (level == 1) {
				return require('@/assets/images/bomb/1.png');
			} 
            else if (level == 2) {
                return require('@/assets/images/bomb/2.png');
			}
            else if (level == 3) {
                return require('@/assets/images/bomb/3.png');
			}
            else if (level == 4) {
                return require('@/assets/images/bomb/4.png');
			}
            else if (level == 5) {
                return require('@/assets/images/bomb/5.png');
			}
			else if (level == 6) {
                return require('@/assets/images/bomb/6.png');
			}
            return require('@/assets/images/bomb/1.png');
		},

        GetBombInfo() {
            BombInfo().then((res) => {
                this.awardList = res.data.data.list;
                this.bean = res.data.data.bean;
                this.currentLayer = res.data.data.current_layer;
                console.log( this.currentLayer);

                this.layer_1 = [];
                this.layer_2 = [];
                this.layer_3 = [];
                this.layer_4 = [];
                this.layer_5 = [];
                this.layer_6 = [];
                if(res.data.data.layer_1){
                    this.layer_1 = res.data.data.layer_1;
                }
                if(res.data.data.layer_2){
                    this.layer_2 = res.data.data.layer_2;
                }
                if(res.data.data.layer_3){
                    this.layer_3 = res.data.data.layer_3;
                }
                if(res.data.data.layer_4){
                    this.layer_4 = res.data.data.layer_4;
                }
                if(res.data.data.layer_5){
                    this.layer_5 = res.data.data.layer_5;
                }             
                if(res.data.data.layer_6){
                    this.layer_6 = res.data.data.layer_6;
                }

            })
        },
        ChangeBomb(v) {
            this.Status = v
            switch (v) {
                case '1':
                    //this.GetRooms()
                    break;
                case '2':
                    //this.GetRoomsEnd()
                    break;
            }
        },
        mouseenter() {
            this.mouseIsUser = true;
        },
        mouseleave() {
            this.mouseIsUser = false;
        },

        //刷新每层奖励
        RandomAward(){
            RandomPrice(1).then((res) => {
                console.log(res);
                this.awardList = res.data.data.list
                this.bean = res.data.data.bean;
                this.currentLayer = res.data.data.current_layer;
            })
        },

        ConfirmBomb(){
            this.showStartTC = true;

        },
        CancelBomb(){
            this.showStartTC = false;
        },

        GetPersonalInfo() {
				PersonalInfo().then((res) => {
					this.User(res.data.message)
				})
			},


        PostStartBomb(){
            StartBomb().then((res) => {
                this.currentLayer = res.data.data.current_layer;
                console.log(this.currentLayer)
                ////关闭确定对话框
                this.showStartTC = false;
                this.GetPersonalInfo();

            })
        },


        PostOpenBomb(layer, cell){
            OpenBomb(layer, cell).then((res) => {
                
                this.currentLayer = res.data.data.current_layer;

                ///行动成功
                if(res.data.data.layer_1){
                    this.layer_1 = res.data.data.layer_1;
                }
                if(res.data.data.layer_2){
                    this.layer_2 = res.data.data.layer_2;
                }
                if(res.data.data.layer_3){
                    this.layer_3 = res.data.data.layer_3;
                }
                if(res.data.data.layer_4){
                    this.layer_4 = res.data.data.layer_4;
                }
                if(res.data.data.layer_5){
                    this.layer_5 = res.data.data.layer_5;
                }             
                if(res.data.data.layer_6){
                    this.layer_6 = res.data.data.layer_6;
                }

                ///行动成功
                if(res.data.data.result == 1){
                    this.sound_1.play();
                    setTimeout(() => {
                        this.award = this.awardList[this.currentLayer-2];
                        this.showAward = true;
                    }, 600)
                }
                else{
                    this.sound_2.play();
                    setTimeout(() => {
                        this.fail_award = res.data.data.fail_award;
                        this.showFailAward = true;
                    }, 600)
                }
            })
        },

        OverBomb(){
            if(this.currentLayer < 2){
                this.$message({
                    message: '还未开始行动，不能放弃',
                    type: 'error'
                })
                return;
            }
            console.log(this.currentLayer);

            this.award = this.awardList[this.currentLayer-2];
            this.showAward = true;
        },

        CloseAwardDlg(){
            this.showAward = false;
        },
        CloseFailAwardDlg(){
            this.showFailAward = false;
        },
        

        ///领取奖励重置行动
        GetAward(type){
            GetBombAward(type).then((res) => {
                //1:领取饰品 2:饰品换成金币
                this.CloseAwardDlg();
                this.CloseFailAwardDlg();
                if (res.data.code == 200) {
                    this.GetBombInfo();

                    if(type== 1){
                        this.$message({
                            message: '已放入背包',
                            type: 'success'
                        })
                    }
                    else{
                        this.$message({
                            message: '回收成功',
                            type: 'success'
                        })
                    }
                } else {

                }
            })

        },
        GetFailAward(){
            this.CloseFailAwardDlg();
            this.$message({
                message: '已放入背包',
                type: 'success'
            })
            this.GetBombInfo();
        },
        PostCash(){
            let data = [];
            data[0] = {
                id: this.fail_award.send_id,
                uuid: this.fail_award.send_uuid,
            }
            console.log(this.fail_award);

            Cash(JSON.stringify(data)).then((res) => {
                this.$notify({
                    message: '放弃成功',
                    type: 'success',
                })
                this.GetPersonalInfo();
                this.GetBombInfo();
            })
            this.CloseFailAwardDlg();
            
        },
        ...mapMutations([
            'User'
        ])

    },
    computed: {
        ...mapState([
            'user'
        ])
    }



}
</script>

<style lang="scss">
.Bomb {
    @keyframes rotateY{
    0% {
        transform: rotateY(250deg)
    }

    to {
        transform: rotateY(1turn)
    }
}

    user-select: none;
    width: 100%;
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
    .startTC_content{
        .startTC_title{
            width: 460px;
            height: 46px;
            font-size: 18px;
            background: #202635;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            position: relative;
        }

        .startTC_bottom{
            width: 460px;
            height: 160px;
            background: #1a1d2a;
            box-sizing: border-box;
            .size{
                padding-top: 35px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 15px;
                font-weight: 500;
                img{
                    width: 17px;
                    height: 17px;
                }
                span{
                    font-size: 15px;
                    font-weight: 500;
                    color: #ffcb77;
                    font-family: "Oxanium";
                }
            }
            .btns{
                margin-top: 35px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .cancel{
                    width: 120px;
                    height: 32px;
                    font-size: 13px;
                    background: #2f3445;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    cursor: pointer;
                }
                .ok{
                    margin-left: 15px;
                    width: 120px;
                    height: 32px;
                    font-size: 13px;
                    color: #fff;
                    background-image: linear-gradient(90deg,#105bb4,#42c0f4);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 2px;
                    cursor: pointer;
                }
            }
        }
    }

    .gxhdcontent{
        width: 360px;
        height: 430px;
        position: relative;
        background-image: url(../../assets/images/bomb/tqz.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
            width: 100%;
            font-size: 15px;
            color: #fff;
            text-align: center;
            margin-top: 10px;
        }
        .gxhdPic{
            width: 100%;
            height: 250px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            img{
                width: 340px;
                height: 230px;
            }
        }
        .price{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 18px;
                height: 18px;
            }
            span{
                font-size: 15px;
                font-family: "Oxanium";
                color: #f8b500;
            }
        }
        .nickname{
            text-align: center;
            font-size: 14px;
            margin-top: 6px;
            width: 100%;
            color: #42c0f4;
        }
        .btns{
            margin-top: 10px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .rs{
                width: 128px;
                height: 28px;
                border-radius: 4px;
                font-size: 14px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #105bb4;
                box-sizing: border-box;
                cursor: pointer;
            }
            .color_rs{
                width: 128px;
                height: 28px;
                border-radius: 4px;
                font-size: 14px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #105bb4;
                box-sizing: border-box;
                margin-left: 10px;
                cursor: pointer;
            }
        }

    }





    .bomb_nav {
        width: 100%;
        height: 80px;
        background-color: #11131D;
        display: flex;
        justify-content: space-between;

        .left_page {
            width: 100%;
            display: flex;
            align-items: center;

            .item {
                width: 220px;
                height: 80px;
                line-height: 80px;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;

                p {
                    color: #ffffff;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    img {
                        width: 20px;
                        margin-right: 2px;
                    }
                }

                i {
                    display: block;
                    width: 100%;
                    height: 2px;
                    position: absolute;
                    background: #91743e;
                    left: 50%;
                    bottom: 0;
                    transform: translateX(-50%);
                    opacity: 0;
                }

                &:hover {
                    background: rgba($color: #ffa07a, $alpha: .03);
                }

                &.active {
                    background: rgba($color: #fff, $alpha: .03);

                    i {
                        opacity: 1;
                    }
                }
            }
        }

    }

    .tdrt {
        margin-left: 16px;
        margin-top: 10px;
        width: 100%;
        height: 50px;
        background-color: #11131D;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;

        .tdrt_left {
            width: 350px;
            height: 42px;
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #ffffff;
            border: 1px solid #3D4467;
            background-blend-mode: normal, normal;
            border-radius: 4px;
            user-select: none;
            transition: all .3s ease;

            &:first-child {
                margin-right: 8px;
            }

            .left_icon {
                margin-left: 10px;
                width: 30px;
                height: 30px;
                background-image: url(../../assets/images/bomb/tdrt_leftbgz.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }

            .text {
                margin-left: 6px;
                display: flex;
                flex-direction: column;
                span {
                    font-size: 14px;
                    color: #3D4467;
                }
            }

        }

        .tdrt_right {
            width: 1010px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .jgqj {
                width: 150px;
                height: 42px;
                border: 1px solid #3D4467;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                position: relative;
             
                span {
                    font-size: 14px;
                    color: #fff;
                }

                img {
                    margin-left: 10px;
                    width: 13px;
                    height: 13px;
                }

                .menu {
                    position: absolute;
                    width: 150px;
                    left: 0px;
                    top: 42px;
                    display: flex;
                    flex-direction: column;
                    z-index: 3;
                    background: #111222;
                    visibility: hidden;
                    z-index: 999;
                    font-size: 14px;

                    &.active {
                        visibility: visible;
                    }
                    .menu_item {
                        z-index: 999;
                        height: 26px;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        margin-bottom: 2px;
                        font-size: 14px;
                        color: #979cc4;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:hover {
                            color: #fff;
                        }
                    }

                }
            }


            .money {
                font-size: 14px;
                color: #fff;
                display: flex;
                align-items: center;

                img {
                    margin-left: 12px;
                    width: 18px;
                    height: 18px;
                }

                span {
                    font-size: 14px;
                    color: #5AE9D3;
                    font-family: "Oxanium";
                    margin-top: 4px;
                }
            }

        }
    }

    .winsbox{
        margin-left: 16px;
        width: 100%;
        height: 200px;
        background-image: url(../../assets/images/bomb/winsboxbg.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;

        .winsbox_left{
            width: 350px;
            height: 180px;
            background-image: url(../../assets/images/bomb/bai.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .winsbox_left_top{
                width: 100%;
                height: 30px;
                font-size: 14px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .line{
                width: 90%;
                height: 1px;
                background: #124371;
            }

            .winsbox_left_bottom{
                width: 100%;
                height: 110px;
                position: relative;
                .Img{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                }
                .name_price{
                    position: absolute;
                    bottom: -30px;
                    width: 100%;
                    padding: 0 15px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    font-size: 12px;
                    .nickname{
                        display: flex;
                        flex-direction: column;
                    }
                }
                .price{
                    display: flex;
                    align-items: center;
                    img{
                        height: 18px;
                        margin-right: 1px;
                    }   
                    span
                    {
                        font-size: 14px;
                        font-weight: 500;
                        color: #ffcb77;
                        font-family: "Oxanium";
                        //margin-top: 1px;
                    }


                }
            }

        }
        .winsbox_right{
            margin-left: 22px;
            display: flex;
            align-items: center;
            height: 100%;
            .up{
                width: 20px;
                height: 30px;
                background-image: url(../../assets/images/bomb/pages.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
            .wins{
                width: 100%;
                height: 100%;
                display: flex;
                .winsCard{
                    height: 190px;
                    width: 150px;
                    background-image: url(../../assets/images/bomb/bai2.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    margin-right: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                    overflow: hidden;
                    .pic{
                        margin-top: 10px;
                        height: 100px;
                        width: 150px;
                        display: flex;
                        align-items: flex-start;
                        justify-content: center;
                        img{
                            width: auto;
                            height: 100px;
                        }
                    }
                    .price{
                        z-index: 1;
                        margin-top: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #ffcb77;
                        font-family: "Oxanium";
                        img{
                            width: 18px;
                            height: 18px;
                        }
                    }
                    .nickname{
                        width: 150px;
                        padding: 0 6px;
                        box-sizing: border-box;
                        font-size: 12px;
                        text-align: center;
                        color: #fff;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        line-clamp: 1;
                    }
                    .dp{
                        margin-top: 2px;
                        width: 20px;
                        height: 20px;
                        img{
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
            }
            .next{
                width: 20px;
                height: 30px;
                background-image: url(../../assets/images/bomb/pages.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                transform: rotateY(180deg);
            }
        }

    }


    .boxs_big{
        margin-left: 16px;
        margin-top: 4px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .boxs_big_left{
            width: 360px;
            .boxs_big_left_top{
                width: 100%;
                height: 200px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .boxs_big_left_top_title{
                    width: 100%;
                    height: 24px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top:1px;
                    box-sizing: border-box;
                }
                .line{
                    width: 90%;
                    height: 1px;
                    background: #124371;
                 }
                 .listbox{
                    width: 360px;
                    margin-top: 6px;
                    .item{
                        width: 330px;
                        height: 42px;
                        border: 1px solid #3D4467;
                        background: #124371;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 15px;
                        margin-left: 10px;
                        margin-top: 30px;
                        .noceng{
                            margin-left: 6px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #fff;
                        }
                        .dao{
                            margin-left: 70px;
                            width: 30px;
                            height: 30px;
                            margin-top: -10px;
                            img{
                                width: 34px;
                                height: 34px;
                            }
                        }
                        .daonum{
                            margin-left: 2px;
                            font-size: 12px;
                            font-weight: 500;
                            color: #fff;
                        }
                        .lei{
                            margin-left: 60px;
                            width: 30px;
                            height: 30px;
                            margin-top: -10px;
                            img{
                                width: 34px;
                                height: 34px;
                            }
                        }
                    }
                 }
            }
        }

        .boxs_big_right{
            width: 100%;
            height: 860px;
            background: rgba(8,24,39,.4);
            padding-top: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .ts{
                width: 100%;
                display: flex;
                justify-content: center;
                margin-bottom: 4px;
                .bgs{
                    width: 110px;
                    height: 110px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    cursor: pointer;
                    position: relative;
                    img{
                        width: 110px;
                        height: 110px;
                    }

                }
                .award{
                    width: 110px;
                    height: 110px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    cursor: pointer;
                    position: relative;
                    background-image: url(../../assets/images/bomb/yes3.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    animation: rotateY 1s forwards;
                    img{
                        width: 80px;
                        height: 80px;
                    }
                }
                .bomb{
                    width: 110px;
                    height: 110px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    cursor: pointer;
                    position: relative;
                    background-image: url(../../assets/images/bomb/no3.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    animation: rotateY 1s forwards;

                    img{
                        width: 80px;
                        height: 80px;
                    }
                }
            }
            .loadings{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,.81);
                display: flex;
                align-items: center;
                justify-content: center;
                .btns{
                    width: 310px;
                    height: 58px;
                    background-image: url(../../assets/images/bomb/btnsbg.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        font-size: 12px;
                        font-weight: 700;
                        color: #fff;
                    }
                    .price{
                        margin-left: 2px;
                        display: flex;
                        align-items: center;
                        img{
                            width: 16px;
                            height: 16px;
                        }
                        span{
                            font-size: 12px;
                            font-weight: 700;
                            color: #f8b500;
                        }
                    }
                }
            }

            .over_btns{
                width: 310px;
                height: 58px;
                background-image: url(../../assets/images/bomb/btnsbg.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

    }


}</style>
